import { Breadcrumbs } from "@sembark-travel/ui-router"
import { generatePath, useNavigate } from "../../../router-utils"
import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"
import { Box, Container } from "@sembark-travel/ui-base"
import { AddNewLeadChannel } from "../../../LeadChannels"

export default function NewLeadChannelsPage() {
	const navigate = useNavigate()
	return (
		<>
			<Helmet>
				<title>New Lead Channels</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_USERS}>
				<Breadcrumbs
					title="New Lead Channels"
					items={[
						[generatePath("/org/lead-channels"), "Lead Channels"],
						["", "New"],
					]}
				/>
				<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
					<Box maxWidth="4xl" marginX="auto">
						<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
							<Container paddingY="6">
								<AddNewLeadChannel
									onSuccess={() =>
										navigate("/org/lead-channels", {
											replace: true,
										})
									}
									onCancel={() =>
										navigate("/org/lead-channels", { replace: true })
									}
								/>
							</Container>
						</Box>
					</Box>
				</Box>
			</ForbidUnlessAuthorized>
		</>
	)
}
